import { cn } from '@/lib/utils'
import MarkerText from './MarkerText'

type Props = {
  text?: string
  color?: string
}

const AssignmentScopeReminderText = ({ text, color }: Props) => {
  if (!text) return null
  return (
    <span
      className={cn(
        'ml-2 inline-flex items-center gap-0.5 flex-wrap align-middle',
        !color && 'text-info-foreground',
      )}
      style={color ? { color } : undefined}
    >
      &quot;
      <MarkerText text={text} />
      &quot;
    </span>
  )
}

export default AssignmentScopeReminderText
